import { DeviceItem, MyProduct } from 'src/model/api/v2/data-contracts';
import { ELECTRICAL_CABINET_SVG } from 'src/icons/planner/ElectricalCabinetIcon';
import { RACK_CABINET_SVG } from 'src/icons/planner/RackCabinetIcon';
import { MY_PRODUCT_SVG } from 'src/icons/planner/MyProductIcon';
import { NOTE_SVG } from 'src/icons/planner/NoteIcon';

function svgToDataUrl(svg: string): string {
    return `data:image/svg+xml;base64,${btoa(svg)}`;
}

export interface DraggableDevice {
    id: string;
    type: string;
    text: string;
    icon: string;
    image: string;
    parent: string;
    input: boolean;
    groupable: boolean;
    serializable: boolean;
    max_serializable: number;
    mergeable: boolean;
    product_id: number;
    is_loxone: boolean;
    has_design: boolean;
    is_nhc: boolean;
    image_url: string | null;
    device_manufacturer: string;
    device_color: string;
    note_message: string;
}

export function mapDeviceItemToDraggable(device: DeviceItem, subcategoryId: number): DraggableDevice {
    return {
        id: `product_${device.id}`,
        type: 'device',
        text: device.text,
        icon: device.icon ?? device.image_url ?? '',
        image: device.image ?? device.icon ?? device.image_url ?? '',
        parent: `category_${subcategoryId}`,
        input: device.input,
        groupable: device.groupable,
        serializable: device.serializable,
        max_serializable: device.max_serializable,
        mergeable: device.mergeable,
        product_id: device.product_id,
        is_loxone: device.is_loxone,
        has_design: device.has_design,
        is_nhc: device.is_nhc,
        image_url: device.image_url,
        device_manufacturer: device.device_manufacturer,
        device_color: device.device_color,
        note_message: device.note_message,
    };
}

export function mapMyProductItemToDraggable(product: MyProduct): DraggableDevice {
    return {
        id: `user_custom_item_${product.userCustomItem.id}`,
        type: 'custom_device',
        text: product.userCustomItem.product_name,
        icon: product.icon_svg ? svgToDataUrl(product.icon_svg) : '',
        image: product.icon_svg ? svgToDataUrl(product.icon_svg) : '',
        parent: 'category_0',
        input: false,
        groupable: false,
        serializable: false,
        max_serializable: 0,
        mergeable: false,
        product_id: product.userCustomItem.id,
        is_loxone: false,
        has_design: false,
        is_nhc: false,
        image_url: null,
        device_manufacturer: '',
        device_color: product.icon_color ?? '',
        note_message: '',
    };
}

export const NEW_CUSTOM_DEVICE_DRAG: DraggableDevice = {
  id: 'new_custom_device',
  type: 'device',
  text: 'New custom item',
  icon: svgToDataUrl(MY_PRODUCT_SVG),
  image: svgToDataUrl(MY_PRODUCT_SVG),
  parent: 'category_0',
  input: false,
  groupable: false,
  serializable: false,
  max_serializable: 0,
  mergeable: false,
  product_id: 0,
  is_loxone: false,
  has_design: false,
  is_nhc: false,
  image_url: null,
  device_manufacturer: '',
  device_color: '',
  note_message: '',
};

export const NEW_NOTE_DRAG: DraggableDevice = {
  id: 'new_note',
  type: 'note',
  text: 'New note',
  icon: svgToDataUrl(NOTE_SVG),
  image: svgToDataUrl(NOTE_SVG),
  parent: 'category_0',
  input: false,
  groupable: false,
  serializable: false,
  max_serializable: 0,
  mergeable: false,
  product_id: 0,
  is_loxone: false,
  has_design: false,
  is_nhc: false,
  image_url: null,
  device_manufacturer: '',
  device_color: '',
  note_message: '',
};

export const ELECTRICAL_CABINET_DRAG: DraggableDevice = {
    id: 'electrical_cabinet',
    type: 'device',
    text: 'Electrical Cabinet',
    icon: svgToDataUrl(ELECTRICAL_CABINET_SVG),
    image: svgToDataUrl(ELECTRICAL_CABINET_SVG),
    parent: 'category_0',
    input: false,
    groupable: false,
    serializable: false,
    max_serializable: 0,
    mergeable: false,
    product_id: 0,
    is_loxone: false,
    has_design: false,
    is_nhc: false,
    image_url: null,
    device_manufacturer: '',
    device_color: '',
    note_message: '',
};

export const RACK_CABINET_DRAG: DraggableDevice = {
    id: 'rack_cabinet',
    type: 'device',
    text: 'Rack Cabinet',
    icon: svgToDataUrl(RACK_CABINET_SVG),
    image: svgToDataUrl(RACK_CABINET_SVG),
    parent: 'category_0',
    input: false,
    groupable: false,
    serializable: false,
    max_serializable: 0,
    mergeable: false,
    product_id: 0,
    is_loxone: false,
    has_design: false,
    is_nhc: false,
    image_url: null,
    device_manufacturer: '',
    device_color: '',
    note_message: '',
};